import { ChangeDetectorRef, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IChecklistTicket } from '../../../../interfaces/checklist-ticket.interface';
import { Observable, of } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-checklist-ticket-media',
  templateUrl: './checklist-ticket-media.component.html',
  styleUrls: ['./checklist-ticket-media.component.scss'],
  standalone: false,
})
export class ChecklistTicketMediaComponent {
  isLoading = false;

  @Input() ticket: IChecklistTicket;
  @Input() downloadMedia: (ticket: IChecklistTicket) => Observable<HttpResponse<Blob>>;

  constructor(private cdr: ChangeDetectorRef) {}

  public handleDownloadMedia(ticket: IChecklistTicket): void {
    this.isLoading = true;
    this.downloadMedia(ticket)
      .pipe(catchError(() => of(null)))
      .subscribe(() => {
        this.isLoading = false;
        this.cdr.markForCheck();
      });
  }
}
